import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CostDistributionItemWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  height: 48px;
  padding: 12px 16px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: ${theme.colors.btnSecondaryHoverBg};

  .item-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .cell {
      color: ${theme.colors.foreground};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }
  }

  .item-right {
    display: flex;
    align-items: center;
    gap: 19px;

    .percent-value {
      color: ${theme.colors.cardDateText};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }

    .cost {
      color: ${theme.colors.foreground};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }
  }
`
